export const BoxModelAside = {
  SizeUnits: {},
  flow: 'x',
  align: 'center center',
  height: '100%',
};